import { createReducer, on } from '@ngrx/store';

import * as columnsAliasesActions from './columns-aliases.actions';
import { ColumnsAliasesState } from './interfaces/columns-aliases.state.interface';
import * as ColumnsAliasesActions from './columns-aliases.actions';

const initState: ColumnsAliasesState = {
  columnsAliases: [],
  loading: false,
  createMode: false,
}

export const columnsAliasesReducers = createReducer(
  initState,
  on(columnsAliasesActions.getColumnsAliases, (state) => ({
    ...state,
    loading: true,
  })),
  on(columnsAliasesActions.getColumnsAliasesSuccess, (state, { columnsAliases }) => ({
    ...state,
    loading: false,
    columnsAliases,
  })),
  on(columnsAliasesActions.getColumnsAliasesFailure, (state) => ({
    ...state,
    loading: false,
  })),
  on(columnsAliasesActions.setColumnsAliases, (state, { columnsAliases }) => ({
    ...state,
    columnsAliases,
  })),
  on(columnsAliasesActions.toggleEditMode, (state, { id }) => ({
    ...state,
    createMode: false,
    columnsAliases: state.columnsAliases
      ?.map(item => item.id === id ? { ...item, editMode: !item?.editMode } : { ...item, editMode: false }),
  })),
  on(columnsAliasesActions.initCreateMode, (state) => ({
    ...state,
    columnsAliases: state.columnsAliases?.map(alias => ({ ...alias, editMode: false })),
    createMode: true,
  })),
  on(columnsAliasesActions.removeCreateMode, (state) => ({
    ...state,
    createMode: false,
  })),
  on(ColumnsAliasesActions.editAliasSuccess, (state, { id, alias, attribute }) => ({
    ...state,
    columnsAliases: state.columnsAliases?.map(columnAlias => {
      if ( columnAlias.id === id ) {
        return {
          ...columnAlias,
          alias, attribute,
        }
      }
      return columnAlias;
    }),
  })),
  on(columnsAliasesActions.clearStore, () => initState),
);
